"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../../");
var Aria_1 = require("../../resources/Aria");
var _1 = require("./");
var Messages = require("../../codegen/Messages");
/**
 * Maps action menu item styles to the desired button style.
 *
 * @param style The style to apply to the button.
 */
function mapToButtonStyle(style) {
    switch (style) {
        case __1.ActionMenuItemButtonStyle.Primary:
        case __1.ActionMenuItemButtonStyle.Success:
            return __1.ButtonStyle.Primary;
        case __1.ActionMenuItemButtonStyle.Danger:
            return __1.ButtonStyle.Danger;
        case __1.ActionMenuItemButtonStyle.Default:
        default:
            return __1.ButtonStyle.Default;
    }
}
var maximumSecondaryButtons = 2;
// See https://confluence.oci.oraclecorp.com/display/UX/Table
exports.listTableHeaderHOC = function (Component) {
    return /** @class */ (function (_super) {
        __extends(ListHeaderTable, _super);
        function ListHeaderTable(props) {
            var _this = _super.call(this, props) || this;
            _this.getSecondaryActionItems = _this.getSecondaryActionItems.bind(_this);
            return _this;
        }
        ListHeaderTable.prototype.getSecondaryActionItems = function () {
            var _a = this.props, id = _a.id, secondaryActions = _a.secondaryActions, selectedIds = _a.selectedIds;
            // Do not render anything if there is no secondary actions
            if (!secondaryActions) {
                return;
            }
            var actions = secondaryActions.actions(selectedIds);
            // The secondary actions will either be rendered as secondary buttons or a dropdown, depending on how many there
            // are
            if (actions.length > maximumSecondaryButtons) {
                return (React.createElement("div", { className: "oui-width-auto" },
                    React.createElement(__1.ActionMenuButton, __assign({ id: id && id + "-action-menu-button", label: Messages.Common.actions(), disabled: this.props.disableControls }, secondaryActions.actionMenuOptions), actions.map(function (action, index) {
                        var onClick = function () { return action.onClick(selectedIds); };
                        return (React.createElement(__1.ActionMenuButtonItem, { key: index, id: id && id + "-action-menu-item-" + index, testId: action.testId, label: action.text, name: action.text, onClick: onClick, disabled: action.disabled, role: Aria_1.Roles.Menuitem, actionStyle: action.actionStyle }));
                    }))));
            }
            else if (actions.length > 0) {
                return actions.map(function (action, index) {
                    var onClick = function () { return action.onClick(selectedIds); };
                    return (React.createElement("div", { className: "oui-width-auto", key: index },
                        React.createElement(__1.Button, { id: id && id + "-secondary-button-" + index, testId: action.testId, buttonStyle: mapToButtonStyle(action.actionStyle), onClick: onClick, disabled: action.disabled }, action.text)));
                });
            }
        };
        ListHeaderTable.prototype.render = function () {
            var _a = this.props, id = _a.id, primaryAction = _a.primaryAction, searchBoxProps = _a.searchBoxProps;
            // There can only be a single primary action, used to create a new item
            var onPrimaryActionClick = primaryAction && (function () { return primaryAction.onClick(); });
            var primaryActionButton = primaryAction && (React.createElement("div", { className: "oui-width-auto" },
                React.createElement(__1.Button, { id: id && id + "-primary-button", testId: primaryAction.testId, buttonStyle: __1.ButtonStyle.Primary, onClick: onPrimaryActionClick, disabled: primaryAction.disabled }, primaryAction.text)));
            var secondaryActionItems = this.getSecondaryActionItems();
            var search = searchBoxProps && (React.createElement("div", { className: "oui-width-auto" },
                React.createElement(__1.SearchBox, __assign({ id: id && id + "-search-box" }, searchBoxProps))));
            // Only render the header if there is content
            var header = !!(primaryActionButton ||
                secondaryActionItems ||
                search) && (React.createElement("div", { className: "oui-flex oui-flex-center oui-flex-wrap oui-grid-small oui-grid", "data-oui-grid": "" },
                primaryActionButton,
                secondaryActionItems,
                React.createElement("div", { className: "oui-flex-auto oui-invisible oui-visible@s", "aria-hidden": "true", role: "presentation" }),
                search));
            return (React.createElement(Component, __assign({}, this.props, { header: header })));
        };
        return ListHeaderTable;
    }(React.Component));
};
// loom-i18n supports plural strings but translation service does not, replace this code once they do
var pluralityAwareitemsShowing = function (numberShowing) {
    return numberShowing === 1
        ? Messages.ListTable.oneItemShowing()
        : Messages.ListTable.itemsShowing(numberShowing);
};
exports.listTableFooterHOC = function (Component) {
    var listFooterTable = function (props) {
        var id = props.id, numberSelectedText = props.numberSelectedText, numberShowingText = props.numberShowingText, paginationProps = props.paginationProps, selectedIds = props.selectedIds, loadingText = props.loadingText, errorText = props.errorText, data = props.data;
        // Assume that number shown and number selectedIds should be 0 if table is loading or there is an error (under the
        // hood, there still could be a non-empty selectedIds or data list, depending on what the consumer passes to us -
        // but none of them will be displayed when loading or error)
        var numberShowing = !!loadingText || !!errorText || !data ? 0 : data.length;
        var numberSelected = selectedIds && numberShowing && selectedIds.length;
        var numberSelectedSpan = numberSelected !== undefined && (React.createElement("span", { className: "oui-width-auto", id: id && id + "-number-selected" }, (numberSelectedText && numberSelectedText(numberSelected)) ||
            Messages.ListTable.itemsSelected(numberSelected)));
        var numberShowingSpan = (React.createElement("span", { className: "oui-width-auto", id: id && id + "-number-showing" }, (numberShowingText && numberShowingText(numberShowing)) ||
            pluralityAwareitemsShowing(numberShowing)));
        var pagination = paginationProps && (React.createElement("div", { className: "oui-width-auto" },
            React.createElement(__1.Pagination, __assign({ id: id && id + "-pagination" }, paginationProps))));
        // Only render the footer if there is content
        var footer = !!(numberSelectedSpan ||
            numberShowingSpan ||
            pagination) && (React.createElement("div", { className: "oui-flex oui-flex-center oui-flex-wrap oui-grid-small oui-grid", "data-oui-grid": "" },
            numberSelectedSpan,
            React.createElement("div", { className: "oui-flex-auto", "aria-hidden": "true", role: "presentation" }),
            numberShowingSpan,
            pagination));
        return React.createElement(Component, __assign({}, props, { footer: footer }));
    };
    return listFooterTable;
};
var listTableHOC = function (Component) {
    return exports.listTableHeaderHOC(exports.listTableFooterHOC(Component));
};
exports.default = listTableHOC;
exports.ListTable = listTableHOC(_1.Table);
// This module provides some common composite HOCs out-of-the-box - if consumers need something more unique, they will
// need to compose it themselves
exports.singleSelectListTableHOC = function (// List table with single-select
Component) {
    return _1.singleSelectTableHOC(listTableHOC(Component));
};
exports.SingleSelectListTable = exports.singleSelectListTableHOC(_1.Table);
exports.multiSelectListTableHOC = function (// List table with multi-select
Component) {
    return _1.multiSelectTableHOC(listTableHOC(Component));
};
exports.MultiSelectListTable = exports.multiSelectListTableHOC(_1.Table);
//# sourceMappingURL=ListTable.js.map